export default [
  {
    title: 'Dashboard',
    route: 'home',
    icon: 'HomeIcon',
    resource: 'APP_DASHBOARD',
    action: 'read',
  },
  {
    title: 'Site Genel',
    route: null,
    icon: 'GlobeIcon',
    children: [
      {
        title: 'Site Menü',
        route: 'SiteMenus',
        resource: 'ADMIN_SITE_MENU',
        action: 'read',
      },
      {
        title: 'Carousel',
        route: 'Carousel',
        resource: 'ADMIN_CAROUSEL',
        action: 'read',
      },
      {
        title: 'Sabit İçerikler',
        route: 'Contents',
        resource: 'ADMIN_CONTENTS',
        action: 'read',
      },
      {
        title: 'Pop-Up Görsel',
        route: 'Popup',
        resource: 'ADMIN_POPUP_LIST',
        action: 'read',
      },
    ],
  },
  {
    title: 'Kurumsal',
    route: null,
    icon: 'FileTextIcon',
    children: [
      {
        title: 'Tarihçe',
        route: 'History',
        resource: 'ADMIN_HISTORY_LIST',
        action: 'read',
      },
      {
        title: 'Hakkımızda',
        route: 'About',
        resource: 'ADMIN_ABOUT',
        action: 'read',
      },
      {
        title: 'Sürdürülebilirlik',
        route: 'Sustainability',
        resource: 'ADMIN_SUSTAINABILITY',
        action: 'read',
      },
      // {
      //   title: 'Bayilikler / Markalar',
      //   route: 'Dealers',
      //   resource: 'ADMIN_DEALERS_LIST',
      //   action: 'read',
      // },
      {
        title: 'İletişim',
        route: 'Contacts',
        resource: 'ADMIN_CONTACT',
        action: 'read',
      },
      {
        title: 'Referanslarımız',
        route: 'References',
        resource: 'ADMIN_REFERENCES_LIST',
        action: 'read',
      },
      {
        title: 'Whatsapp',
        route: 'Whatsapp',
        resource: 'ADMIN_WHATSAPP',
        action: 'read',
      },
    ],
  },
  // {
  //   title: 'Kataloglar',
  //   route: 'Certificates',
  //   icon: 'LayersIcon',
  //   resource: 'ADMIN_CERTIFICATES_LIST',
  //   action: 'read',
  // },
  // {
  //   title: 'Haberler',
  //   route: 'Blog',
  //   icon: 'BookIcon',
  //   children: [
  //     {
  //       title: 'Oluştur',
  //       route: 'BlogAdd',
  //       resource: 'ADMIN_BLOG_ADD',
  //       action: 'read',
  //     },
  //     {
  //       title: 'Listele',
  //       route: 'Blog',
  //       resource: 'ADMIN_BLOG_LIST',
  //       action: 'read',
  //     },
  //     {
  //       title: 'Kategoriler',
  //       route: 'BlogCategories',
  //       resource: 'ADMIN_BLOG_CATEGORIES_LIST',
  //       action: 'read',
  //     },
  //   ],
  // },
  // {
  //   title: 'Üretim',
  //   route: 'Production',
  //   icon: 'ApertureIcon',
  //   children: [
  //     {
  //       title: 'Oluştur',
  //       route: 'ProductionAdd',
  //       resource: 'ADMIN_PRODUCTION_ADD',
  //       action: 'read',
  //     },
  //     {
  //       title: 'Listele',
  //       route: 'Production',
  //       resource: 'ADMIN_PRODUCTION_LIST',
  //       action: 'read',
  //     },
  //   ],
  // },
  // {
  //   title: 'Koleksiyonlar',
  //   route: 'Collections',
  //   icon: 'LayersIcon',
  //   children: [
  //     {
  //       title: 'Oluştur',
  //       route: 'CollectionsAdd',
  //       resource: 'ADMIN_COLLECTIONS_ADD',
  //       action: 'read',
  //     },
  //     {
  //       title: 'Listele',
  //       route: 'Collections',
  //       resource: 'ADMIN_COLLECTIONS_LIST',
  //       action: 'read',
  //     },
  //   ],
  // },
  {
    title: 'Projeler',
    route: null,
    icon: 'BoxIcon',
    children: [
      {
        title: 'Proje Listesi',
        route: 'Products',
        resource: 'ADMIN_PRODUCTS',
        action: 'read',
      },
      {
        title: 'Proje Grupları',
        route: 'ProductGroups',
        resource: 'ADMIN_PRODUCTS',
        action: 'read',
      },
      // {
      //   title: 'Ürün Renkleri/Özellikleri',
      //   route: 'Features',
      //   resource: 'ADMIN_DEFINES_ALL',
      //   action: 'read',
      // },
      // {
      //   title: 'Ürün Özellik Grupları',
      //   route: 'FeatureGroups',
      //   resource: 'ADMIN_DEFINES_ALL',
      //   action: 'read',
      // },
      // {
      //   title: 'Ürün Reynaers/Rehau Ürün Özellikleri',
      //   route: 'ProductReynaersCat',
      //   resource: 'ADMIN_PRODUCTS_REYNAERS_CAT',
      //   action: 'read',
      // },
    ],
  },
  {
    title: 'İletişim Formları',
    route: null,
    icon: 'EditIcon',
    children: [
      // {
      //   title: 'Açık Pozisyonlar',
      //   route: 'HrPositions',
      //   resource: 'ADMIN_HR_POSITIONS_LIST',
      //   action: 'read',
      // },
      {
        title: 'Formlar',
        route: 'WebForms',
        resource: 'ADMIN_WEBFORMS',
        action: 'read',
      },
    ],
  },
  // {
  //   title: 'Galeri',
  //   route: null,
  //   icon: 'CameraIcon',
  //   children: [
  //     {
  //       title: 'Fotoğraf Galerisi',
  //       route: 'ImageGallery',
  //       resource: 'ADMIN_PHOTO_GALLERY',
  //       action: 'read',
  //     },
  //     // {
      //   title: 'Video Galerisi',
      //   route: 'VideoGallery',
      //   resource: 'ADMIN_VIDEO_GALLERY',
      //   action: 'read',
      // },
    // ],
  // },
  {
    title: 'Modüller',
    route: null,
    icon: 'CodesandboxIcon',
    children: [
      {
        title: 'Sosyal Medya',
        route: 'Socialmedia',
        resource: 'ADMIN_MODULES',
        action: 'read',
      },
    ],
  },
  {
    title: 'Dil Çeviri',
    route: null,
    icon: 'FlagIcon',
    children: [
      {
        title: 'Çeviri Listesi',
        route: 'Translate',
        resource: 'ADMIN_TRANSLATE',
        action: 'read',
      },
    ],
  },
  {
    title: 'Kullanıcılar',
    route: 'Users',
    icon: 'UsersIcon',
    children: [
      {
        title: 'Kullanıcılar',
        route: 'Users',
        resource: 'ADMIN_USERS',
        action: 'read',
      },
      {
        title: 'Kullanıcı Yetkileri',
        route: 'UserTypes',
        resource: 'ADMIN_USER_TYPES',
        action: 'read',
      },
    ],
  },
  {
    title: 'Ayarlar',
    route: null,
    icon: 'SettingsIcon',
    children: [
      {
        title: 'Genel Yapılandırma',
        route: 'Configs',
        resource: 'ADMIN_CONFIG',
        action: 'read',
      },
      {
        title: 'SEO Yapılandırma',
        route: 'Components',
        resource: 'ADMIN_CONFIG',
        action: 'read',
      },
      {
        title: 'SMTP',
        route: 'Smtp',
        resource: 'ADMIN_SMTP',
        action: 'read',
      },
    ],
  },
]
